import { library } from '@fortawesome/fontawesome-svg-core'

import { 
        faServer, faEnvelope, faHandPointer, faNewspaper, 
        faCircleLeft, faMobile, faAnglesRight, faChevronDown
} from '@fortawesome/free-solid-svg-icons'
import { faAndroid, faApple, faLinkedin, faGithub } from '@fortawesome/free-brands-svg-icons'

library.add(
    faServer, faAndroid, faApple, faLinkedin, 
    faEnvelope, faHandPointer, faNewspaper, faCircleLeft, 
    faMobile, faAnglesRight, faGithub, faChevronDown
);
